import React from 'react';

const DockFilter = ({
    factories,
    doorGroups,
    docks,
    filters,
    onFilterChange,
    isOpen,
    toggleOpen
}) => {

    const relevantGroups = filters.factory === 'all'
        ? doorGroups
        : doorGroups.filter(g => g.factoryId === filters.factory);

    const relevantDocks = filters.doorGroup === 'all'
        ? (filters.factory === 'all' ? docks : docks.filter(d => relevantGroups.some(g => g.id === d.doorGroupId)))
        : docks.filter(d => d.doorGroupId === filters.doorGroup);

    return (
        <div className="dock-filter-container">
            <div className="dock-filter-header" onClick={toggleOpen}>
                <h3 style={{ margin: 0, fontSize: '1.2rem' }}>
                    {filters.dock !== 'all'
                        ? docks.find(d => d.id === filters.dock)?.name
                        : 'Lütfen Rampa Seçiniz'}
                </h3>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>

            {isOpen && (
                <div className="dock-filter-content">
                    {/* Factory Select */}
                    <div>
                        <label className="text-secondary text-sm mb-1 block">Fabrika</label>
                        <select
                            className="dock-input"
                            value={filters.factory}
                            onChange={(e) => onFilterChange('factory', e.target.value)}
                        >
                            <option value="all">Tüm Fabrikalar</option>
                            {factories.map(f => (
                                <option key={f.id} value={f.id}>{f.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Group Select */}
                    <div>
                        <label className="text-secondary text-sm mb-1 block">Rampa Grubu</label>
                        <select
                            className="dock-input"
                            value={filters.doorGroup}
                            onChange={(e) => onFilterChange('doorGroup', e.target.value)}
                        >
                            <option value="all">Tüm Gruplar</option>
                            {relevantGroups.map(g => (
                                <option key={g.id} value={g.id}>{g.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Dock Select */}
                    <div>
                        <label className="text-secondary text-sm mb-1 block">Rampa</label>
                        <select
                            className="dock-input"
                            value={filters.dock}
                            onChange={(e) => onFilterChange('dock', e.target.value)}
                        >
                            <option value="all">Tüm Rampalar</option>
                            {relevantDocks.map(d => (
                                <option key={d.id} value={d.id}>{d.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DockFilter;
